module.exports = __webpack_public_path__ + "img/image1.b2a57606.jpg";